import React from 'react';

/**
 * Layout-matching loading skeleton (D5). Mirrors the real verification card's
 * structure (header bar, image block, identity lines, ownership rows, CTA block)
 * so content doesn't "jump" when mirror data arrives.
 */
const Bar: React.FC<{ className?: string }> = ({ className }) => (
  <div className={`bg-gray-200 rounded animate-pulse ${className || ''}`} />
);

const VerifySkeleton: React.FC = () => (
  <div className="border border-gray-200 rounded-lg overflow-hidden" aria-busy="true" aria-label="Verifying TTR code">
    <div className="h-2 bg-gray-200 animate-pulse" />
    <div className="px-5 py-3 bg-white flex items-center justify-between">
      <Bar className="h-4 w-40" />
      <Bar className="h-5 w-24" />
    </div>

    <div className="px-5 py-6 bg-gray-50 flex flex-col sm:flex-row gap-5">
      <Bar className="w-40 h-56 mx-auto sm:mx-0 flex-shrink-0" />
      <div className="flex-1 space-y-3 w-full">
        <Bar className="h-7 w-3/4" />
        <Bar className="h-4 w-1/2" />
        <div className="flex gap-2 pt-1">
          <Bar className="h-7 w-28" />
          <Bar className="h-7 w-16" />
        </div>
        <Bar className="h-3 w-full mt-3" />
        <Bar className="h-3 w-5/6" />
        <Bar className="h-3 w-2/3" />
      </div>
    </div>

    <div className="px-5 py-4 bg-white space-y-2">
      <Bar className="h-4 w-full" />
      <Bar className="h-4 w-3/4" />
      <Bar className="h-4 w-2/3" />
    </div>

    <div className="px-5 py-6 bg-gray-100">
      <Bar className="h-5 w-2/3 mb-3" />
      <Bar className="h-11 w-44" />
    </div>
  </div>
);

export default VerifySkeleton;
